import type { MasteryMapStore } from './interfaces'

export const actions = {
  setDocument (this: MasteryMapStore, payload: MasteryMapStore['document']): void {
    this.document = payload
  },
  setLoading (this: MasteryMapStore, payload: MasteryMapStore['loading']): void {
    this.loading = payload
  },
  setList (this: MasteryMapStore, payload: MasteryMapStore['list']): void {
    this.list = payload
  },
  setListLoading (this: MasteryMapStore, payload: MasteryMapStore['listLoading']): void {
    this.listLoading = payload
  },
}
